import { noneGroupHeader } from "./noneGroupHeader.locstring.json";
import loc from "owa-localize";
import generateTimeGroupHeaders from "./generateTimeGroupHeaders";
import type TimeGroupHeader from "../type/TimeGroupHeader";
import type { OwaDate } from "owa-datetime";
import { isBefore, isSameDay } from "owa-datetime";
import { NoGroupHeaderId } from "../type/GroupHeaderId";
import { observableToday } from "owa-observable-datetime";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import { isWin32StylingEnabled } from "owa-theme-win32-style-store";

let timeGroupHeaders: TimeGroupHeader[] = [];
let todayUsedToGenerateTimeHeaders: OwaDate;
let win32StylingEnabledUsedToGenerateTimeHeaders: boolean;

// initialize group headers
function initializeTimeGroupHeaders(today: OwaDate, win32StylingEnabled: boolean) {
    // WeekStartDay is optional in the user configuration; default to Sunday (0) so week/weekday
    // math never receives undefined (which would produce NaN indices and undefined headers).
    const weekStartDay = getUserConfiguration().UserOptions?.WeekStartDay ?? 0;
    timeGroupHeaders = generateTimeGroupHeaders(today, weekStartDay);
    todayUsedToGenerateTimeHeaders = today;
    win32StylingEnabledUsedToGenerateTimeHeaders = win32StylingEnabled;
}

/**
 * Get group time header for a given time
 * @param date for which to get time group header
 * @return time group header for a given time
 */
export function getTimeGroupHeader(date: OwaDate): TimeGroupHeader {
    // Generate the group header date ranges if they were not generated ever, the day has
    // changed since they were generated, or the Win32 styling setting has been toggled
    // (which changes which set of headers should be shown).
    const today = observableToday();
    const win32StylingEnabled = isWin32StylingEnabled();
    if (timeGroupHeaders.length == 0 ||
        !isSameDay(todayUsedToGenerateTimeHeaders, today) ||
        win32StylingEnabled !== win32StylingEnabledUsedToGenerateTimeHeaders) {
        initializeTimeGroupHeaders(today, win32StylingEnabled);
    }
    
    for (let i = 0; i < timeGroupHeaders.length; i++) {
        const timeRange = timeGroupHeaders[i];
        
        // Check if the time is within range by including lower time boundary but excluding upper boundary
        if (!isBefore(date, timeRange.rangeStartTime) && isBefore(date, timeRange.rangeEndTime)) {
            return timeRange;
        }
    }
    
    // If an item is not in defined group ranges return none type. It should be very rare but in the
    // past we have seen instances of Tomorrow header e.g. in case timer callback is not triggered.
    return {
        headerText: () => loc(noneGroupHeader),
        headerId: NoGroupHeaderId.None,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (62,9): Type 'null' is not assignable to type 'OwaDate'.
        // @ts-expect-error
        rangeStartTime: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (66,9): Type 'null' is not assignable to type 'OwaDate'.
        // @ts-expect-error
        rangeEndTime: null,
    };
}
